const fontNames = [
    "eramCpdlc1",
    "eramCpdlc2",
    "eramCpdlc3",
    "eramCpdlc4",
    "eramCpdlc5",
    "edstText2",
    "eramText1",
    "eramText2",
    "eramText3",
    "eramText4",
    "eramText5",
    "eramText6",
    "eramText7",
    "eramText8",
    "eramGeomapSymbols1",
    "eramGeomapSymbols2",
    "eramGeomapSymbols3",
    "eramGeomapSymbols4",
    "eramPositionSymbols1",
    "eramTargetSymbols1",
];
export const edstFontName = "edstText2";
export const eramSymbolFontNameMap = {
    1: "eramGeomapSymbols1",
    2: "eramGeomapSymbols2",
    3: "eramGeomapSymbols3",
    4: "eramGeomapSymbols4",
};
export const eramFontNameMap = {
    1: "eramText1",
    2: "eramText2",
    3: "eramText3",
    4: "eramText4",
    5: "eramText5",
    6: "eramText6",
    7: "eramText7",
    8: "eramText8",
};
export const eramCpdlcFontNameMap = {
    1: "eramCpdlc1",
    2: "eramCpdlc2",
    3: "eramCpdlc3",
    4: "eramCpdlc4",
    5: "eramCpdlc5",
};
export const eramFontDimensionMap = {
    eramCpdlc1: { height: 12, width: 10 },
    eramCpdlc2: { height: 16, width: 14 },
    eramCpdlc3: { height: 18, width: 15 },
    eramCpdlc4: { height: 16, width: 14 },
    eramCpdlc5: { height: 16, width: 14 },
    eramGeomapSymbols1: { height: 15, width: 13 },
    eramGeomapSymbols2: { height: 17, width: 17 },
    eramGeomapSymbols3: { height: 19, width: 19 },
    eramGeomapSymbols4: { height: 19, width: 19 },
    eramPositionSymbols1: { height: 15, width: 12 },
    eramTargetSymbols1: { height: 15, width: 12 },
    edstText2: { height: 17, width: 11 },
    eramText1: { height: 12, width: 10 },
    eramText2: { height: 17, width: 12 },
    eramText3: { height: 19, width: 14 },
    eramText4: { height: 19, width: 16 },
    eramText5: { height: 21, width: 17 },
    eramText6: { height: 24, width: 20 },
    eramText7: { height: 30, width: 22 },
    eramText8: { height: 36, width: 28 },
};
export const edstFontDim = eramFontDimensionMap.edstText2;
export const eramTextDimensionMap = {
    1: eramFontDimensionMap.eramText1,
    2: eramFontDimensionMap.eramText2,
    3: eramFontDimensionMap.eramText3,
    4: eramFontDimensionMap.eramText4,
    5: eramFontDimensionMap.eramText5,
};
export function getBitmapTextStyles(fontFamily) {
    return {
        fontFamily,
        fontSize: eramFontDimensionMap[fontFamily].height,
    };
}
//# sourceMappingURL=eramFont.js.map